

export interface ModifyDatabaseTopologyResult {
    raftCommandIndex: number;
}
